import Heading from '@components/Heading/Heading';
import styles from '@features/cms/components/inspirations/InspirationPremiumIdeaBlock/InspirationPremiumIdeaBlock.styles';
import sanitizeHtml from '@utils/sanitizeHtml';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  children: React.ReactNode;
  title: string;
  image: string;
};
const ImageWithText = ({
  title,
  children,
  image
}: PropsType) => <div sx={styles.imgWithText}>
    <Heading h={1} display={2} mobile addSx={styles.heading}>
      <span dangerouslySetInnerHTML={sanitizeHtml(title)} />
    </Heading>
    <div sx={styles.imageWithTextContent}>
      {children}
      <div sx={styles.imgContainer}>{image && <ResponsiveImage image={image} alt={title ?? ''} />}</div>
    </div>
  </div>;
export default ImageWithText;